// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1zIJx","left":"InfoRow_left__3XJv8"};